module.exports = __webpack_public_path__ + "static/img/circulation.6ed4fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/package-service/circulation.png
// module id = xz+g
// module chunks = 2